import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import DivLayout from 'components/sales/divLayout/divLayout';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';

const ViewDetail = ({ getInvoiceList, invoiceList, match }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [roleId, setRoleId] = useState();
  const detailsDiv = ['detail_view', 'site_detail', 'billing_detail'];

  useEffect(() => {
    (async () => {
      const invoiceData =
        (await JSON.parse(localStorage.getItem('viewDetail'))) &&
        JSON.parse(localStorage.getItem('viewDetail'));

      setRoleId(localStorage.getItem('fusion-role'))
      invoiceData && invoiceData.length > 0 && setData(invoiceData[0]);
    })();
  }, []);

  const headerBtns = () => {
    return (
      <Link
        to={`/dashboard/brand-activation/conduct-camp/payment/${match.params.id}`}
        className="btn btn-primary"
      >
        {localization.makePayment}
      </Link>
    );
  };

  return (
    <Layout
      title={localization.BacktoList}
      isLoading={isLoading}
      isGoback
      Buttons={parseInt(setRoleId) !== 55 ? headerBtns : ""}
      linkUrl={`${baseUrl}/brand-activation/invoice`}
    >
      {data !== null &&
        detailsDiv.map((div) => {
          if (
            data[div] &&
            data[div][0] !== undefined &&
            data[div][0].length > 0
          ) {
            return (
              <div className="panel-card">
                <div className="panel-heading">
                  {div.split('_').join(' ').toUpperCase()}
                </div>
                <div className="panel-body">
                  <div className="details-listing">
                    {data[div] &&
                      data[div][0] !== undefined &&
                      data[div][0].length > 0 &&
                      data[div][0].map((obj) => {
                        return (
                          <DivLayout heading={obj.lable} data={obj.value} />
                        );
                      })}
                  </div>
                </div>
              </div>
            );
          }
        })}

      {data !== null && (
        <div className="panel-card">
          <div className="panel-heading">
            {'line_item'.split('_').join(' ').toUpperCase()}
          </div>
          <div className="panel-body">
            <div className="details-listing">
              {data.line_item &&
                data.line_item[0][0] !== undefined &&
                data.line_item[0][0].length > 0 &&
                data.line_item[0][0].map((obj) => {
                  return <DivLayout heading={obj.lable} data={obj.value} />;
                })}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

ViewDetail.propTypes = {
  invoiceList: PropTypes.any,
  getInvoiceList: PropTypes.func,
  match: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default ViewDetail;
